import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { company } from '../config/company';
import s from '../styles/legalStyles';

const handleOpenPreferences = () => {
  // Clear consent so the banner reappears
  localStorage.removeItem('casaothers_cookie_consent');
  window.dispatchEvent(new Event('cookie-consent-reset'));
};

const CookiesPolicy = () => {
  return (
    <div style={s.page}>
      <SEO
        title="Polityka plików cookie"
        description={`Polityka plików cookie ${company.brand}. Jakie pliki cookie wykorzystujemy i jak zarządzać preferencjami.`}
      />
      <div style={s.container}>
        <h1 style={s.title}>Polityka plików cookie</h1>
        <p style={s.lastUpdated}>
          Ostatnia aktualizacja: {company.effectiveDate}
        </p>

        <article style={s.article}>
          <p>
            {company.brand} wykorzystuje pliki cookie i podobne technologie, aby strona działała prawidłowo,
            analizować jej użytkowanie i poprawiać Twoje doświadczenie. W niniejszej polityce wyjaśniamy, jakie
            pliki cookie wykorzystujemy i jak możesz nimi zarządzać.
          </p>

          <h2 style={s.h2}>1. Czym są pliki cookie?</h2>
          <p>
            Pliki cookie to małe pliki tekstowe umieszczane na Twoim urządzeniu podczas odwiedzania naszej strony.
            Pomagają nam zapamiętać preferencje i mierzyć użytkowanie.
          </p>

          <h2 style={s.h2}>2. Jakie pliki cookie wykorzystujemy?</h2>

          <h3 style={s.h3}>2.1 Pliki funkcjonalne (zawsze aktywne)</h3>
          <p>Te pliki są niezbędne do działania strony. Nie można ich wyłączyć.</p>
          <ul style={s.list}>
            <li><strong>casaothers_lang</strong> — zapamiętuje preferencje językowe. Okres: 1 rok.</li>
            <li><strong>casaothers_admin_token</strong> — logowanie administratora (tylko dla administratorów). Okres: 7 dni.</li>
            <li><strong>casaothers_cookie_consent</strong> — zapamiętuje Twoje preferencje dotyczące cookie. Okres: 1 rok.</li>
          </ul>

          <h3 style={s.h3}>2.2 Pliki analityczne (wymagana zgoda)</h3>
          <p>
            Wykorzystujemy <strong>Google Analytics 4</strong> i <strong>Google Tag Manager</strong>, aby anonimowo
            zrozumieć, jak odwiedzający korzystają z naszej strony. Pomaga nam to ulepszać doświadczenie użytkownika
            i optymalizować ofertę.
          </p>
          <ul style={s.list}>
            <li><strong>_ga</strong>, <strong>_ga_*</strong> — Google Analytics 4. Okres: 13 miesięcy.</li>
            <li><strong>_gid</strong> — rozróżnia unikalnych odwiedzających. Okres: 24 godziny.</li>
            <li><strong>_gat</strong> — ogranicza liczbę żądań. Okres: 1 minuta.</li>
          </ul>
          <p>Zawarliśmy umowę powierzenia przetwarzania danych z Google i włączyliśmy anonimizację IP tam, gdzie to możliwe.</p>

          <h2 style={s.h2}>3. Zarządzanie preferencjami</h2>
          <p>
            Możesz w każdej chwili zaktualizować swoje preferencje dotyczące cookie za pomocą poniższego przycisku
            lub usuwając pliki cookie w ustawieniach przeglądarki.
          </p>
          <button style={s.button} onClick={handleOpenPreferences} data-testid="reset-cookie-consent-button">
            Zresetuj preferencje cookie
          </button>

          <h2 style={s.h2}>4. Wyłączanie plików cookie w przeglądarce</h2>
          <p>Możesz również wyłączyć pliki cookie w ustawieniach przeglądarki:</p>
          <ul style={s.list}>
            <li><a style={s.link} href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
            <li><a style={s.link} href="https://support.mozilla.org/pl/kb/usuwanie-ciasteczek" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a style={s.link} href="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
            <li><a style={s.link} href="https://support.microsoft.com/pl-pl/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          </ul>

          <h2 style={s.h2}>5. Pytania?</h2>
          <p>
            Napisz do nas na <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a>. Zobacz także naszą{' '}
            <Link style={s.link} to="/privacy">politykę prywatności</Link>.
          </p>
        </article>
      </div>
    </div>
  );
};

export default CookiesPolicy;
